import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import fromGangnam from '@/pages/fromGangnam'
import intro from '@/pages/intro'
import introDB from '@/pages/intro-db'
import userTerms from '@/pages/user-terms'
import OL from '@/pages/Intro/OL'
import userTermsWOCode from '@/pages/user-terms-without-code'
import checkupLayout from "@/pages/checkup/checkupLayout.vue"
import checkupStep1 from "@/pages/checkup/step1.vue"
import checkupStep2 from "@/pages/checkup/step2.vue"
import checkupStep3 from "@/pages/checkup/step3.vue"
import checkupStep4 from "@/pages/checkup/step4.vue"
import checkupStep5 from "@/pages/checkup/step5.vue"
import checkupStep51 from "@/pages/checkup/step5-1.vue"
import checkupStep6 from "@/pages/checkup/step6.vue"
import checkupStep61 from "@/pages/checkup/step6-1.vue"
import checkupStep62 from "@/pages/checkup/step6-2.vue"
import checkupStep7 from "@/pages/checkup/step7.vue"
import checkupStep8 from "@/pages/checkup/step8.vue"
import checkupStep9 from "@/pages/checkup/step9.vue"
import checkupStep10 from "@/pages/checkup/step10.vue";
import checkupStep11 from "@/pages/checkup/step11.vue";
import reportOverview from "@/pages/checkup/reportOverview.vue"
import reportSample from "@/pages/checkup/reportSample.vue"
import guideDisease from "@/pages/checkup/guideDisease.vue"
import guideExercise from "@/pages/checkup/guideExercise.vue"
import guideDiet from "@/pages/checkup/guideDiet.vue"
import splash from '@/pages/shinhan/splash.vue'
import splashShinhan from '@/pages/shinhan/splash_shinhan.vue'
import introShinhan from '@/pages/shinhan/intro_shinhan.vue'
import introMG from '@/pages/intro-mg'
import Playground from '../pages/Playground'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'splash',
            component: splash
        },
        {
            path: '/sh',
            name: 'splashShinhan',
            component: splashShinhan
        },
        {
            path: '/fromGangnam',
            name: 'fromGangnam',
            component: fromGangnam
        },
        {
            path: '/intro',
            name: 'intro',
            component: intro
        },
        {
            path: '/ol',
            name: 'IntroOrangeLife',
            component: intro
        },
        {
            path: '/mg',
            name: 'introMG',
            component: introMG
        },
        {
            path: '/introShinhan',
            name: 'introShinhan',
            component: introShinhan
        },
        {
            path: '/intro-db',
            name: 'introDB',
            component: introDB
        },
        {
            path: '/Playground',
            name: 'Playground',
            component: Playground

        },
        {
            path: '/userTerms',
            name: 'userTerms',
            component: userTerms
        },
        {
            path: '/userTermsWOCode',
            name: 'userTermsWOCode',
            component: userTermsWOCode
        },
        {
            path: '/checkup',
            component: checkupLayout,
            children: [
                {
                    path: "step1",
                    component: checkupStep1
                },
                {
                    path: "step2",
                    component: checkupStep2
                },
                {
                    path: "step3",
                    component: checkupStep3
                },
                {
                    path: "step4",
                    component: checkupStep4
                },
                {
                    path: "step5",
                    component: checkupStep5
                },
                {
                    path: "step51",
                    component: checkupStep51
                },
                {
                    path: "step6",
                    component: checkupStep6
                },
                {
                    path: "step61",
                    component: checkupStep61
                },
                {
                    path: "step62",
                    component: checkupStep62
                },
                {
                    path: "step7",
                    component: checkupStep7
                },
                {
                    path: "step8",
                    component: checkupStep8
                },
                {
                    path: "step9",
                    component: checkupStep9
                },
                {
                    path: "step10",
                    component: checkupStep10
                },
                {
                    path: "step11",
                    component: checkupStep11
                },
                {
                    path: "reportOverview",
                    component: reportOverview
                },
                {
                    path: "reportSample",
                    component: reportSample
                },
                {
                    path: "guideDisease",
                    component: guideDisease,
                    meta: { menu: false, title: '결과 분석 가이드' }
                },
                {
                    path: "guideExercise",
                    component: guideExercise,
                    meta: { menu: false, title: '결과 분석 가이드' }
                },
                {
                    path: "guideDiet",
                    component: guideDiet,
                    meta: { menu: false, title: '결과 분석 가이드'}
                },
            ]
        },
    ]
})

router.beforeEach((to, from, next) => {
    const user = store.getters['user/getUser']

    if ( to.path.includes('checkup/') && user.authToken === null ) {
        alert('인증 정보가 없어 초기화면으로 이동합니다.')
        next('/intro')
        return
    }
    next()
})

export default router
